import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
`;

export default Container;
